import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ImageUrl } from "../const";

const CardContainer = styled.a`
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  background-color: white;
  cursor: pointer;
  text-decoration: none;
  user-select: none;
  &:hover {
    .toolkit {
      transform: translateY(0%);
    }
  }
  &.disable{
  cursor: default !important;
  }
  @media screen and (max-width: 635px) {
    width: calc(50% - 10px);
  }
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  margin-top: -15px;
  p {
    color: black;
    @media screen and (min-width: 769px) and (max-width: 1024px) {
      font-size: 14px;
    }
    @media screen and (max-width: 420px) {
      font-size: 14px;
    }
  }
`;

const Toolkit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: #ffffff90;
  position: absolute;
  /* backdrop-filter:blur(5px); */
  top: 0;
  transition: 0.5s ease-in-out;
  transform: translateY(-100%);
  h1 {
    color: black;
    font-size: 20px !important;
    user-select: none;
    @media screen and (max-width: 420px) {
      font-size: 14px !important;
    }
  }
`;

function Cards({ data }) {
  const { t } = useTranslation();

  return (
    <CardContainer href={data.isLaunched ? `/${data.slug}` : null} className={!data.isLaunched && "disable" }>
      <img
        src={ImageUrl + data.gameImage}
        style={{ width: "100%", objectFit: "cover" }}
        alt=""
      />
      <NameContainer>
        <p>{t(`${data.name}`)}</p>
      </NameContainer>
      {!data.isLaunched && (
        <Toolkit className="toolkit">
          <h1 style={{ textAlign: "center" }}>{t("coming_soon")}</h1>
        </Toolkit>
      )}
    </CardContainer>
  );
}

export default Cards;
